import React from 'react';

import { ISO_DATE_FORMAT } from '@gasbi/shared';
import dayjs from 'dayjs';
import { Navigate } from 'react-router-dom';

import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';

const Imbalances = React.lazy(() => import('./index'));
const OperatorDetail = React.lazy(() => import('./views/OperatorDetail'));

const handle = { permissions: UserPermissions.GasBalanceImbalanceRead };

/** `:date` names the gas day the page shows; `:operatorId` the ОГРМ whose points the table opened. */
const imbalancesRoute = [
  {
    path: Pages.IMBALANCES,
    element: (
      <Navigate
        to={`./${dayjs().format(ISO_DATE_FORMAT)}`}
        relative='path'
        replace
      />
    ),
    handle,
  },
  {
    path: `${Pages.IMBALANCES}/:date`,
    element: <Imbalances />,
    handle,
  },
  {
    path: `${Pages.IMBALANCES}/:date/:operatorId`,
    element: <OperatorDetail />,
    handle,
  },
];

export default imbalancesRoute;
